/**
 * 描述：公用添加用户弹框
 * 作者：
 * 日期：
 */
"use strict";
angular.module("selectUsersServiceModule", ["selectUsersModule"])
    .factory("selectUsersService", ["$q", "$uibModal", function($q, $uibModal) {
        return {
            /**
             * [selectusers description] 根据部门选择用户
             * 
             */
            selectusers: function(item) {
                var deffer = $q.defer();
                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'util/selectUsers/selectUsers_tpl.html',
                    controller: 'selectUsersCtrl',
                    windowClass: 'selectUsers',
                    backdrop: false,
                    resolve: {
                        item: function() {
                            return item;
                        }
                    }
                });
                modalInstance.result.then(function(data) {
                    deffer.resolve(data);
                }, function() {
                    //deffer.reject();
                });
                return deffer.promise;
            }
        };
    }]);
